import { render, staticRenderFns } from "./ProgressStudentList.vue?vue&type=template&id=1b2c5e65&"
import script from "./ProgressStudentList.vue?vue&type=script&lang=ts&"
export * from "./ProgressStudentList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports